/* eslint-disable max-len */
import React, { useRef, useState, useEffect } from "react";
// import { useOnClickOutside } from "../../../CommonMethods/OutsideClick";

export default function PatientDropdownWithSearch({
    id,
    placeholder,
    value,
    disabled,
    emptyField,
    organizationData,
    organizationFetching,
    handleOrganizationListSearch,
    handleFetchSubdivision,
    selectedOrganizationName,
    setisOpen,
    isOpen,
    optionId,
    isMonitor,
    linkOrganizationModel

}
) {

    const ref = useRef(null);
    const [displayEmptyMsg, setDisplayEmptyMsg] = useState('')
    const buttonRef = useRef(null);
    const dropdownRef = useRef(null);
    const inputRef = useRef(null);
    const [isOpenorgDiv, setIsOpenorgDiv] = useState(false);

    /* The `useEffect` hook is used to perform side effects in a React component. In this case, the
   effect is triggered when the `organizationData` variable changes. */
    useEffect(() => {
        if (organizationData !== undefined) {
            if (organizationData?.data?.length === 0) {
                setDisplayEmptyMsg('No results found.')
                return
            }
            setDisplayEmptyMsg('')
        }
    }, [organizationData])

    // useOnClickOutside(ref, () => {
    //     setisOpen(false)
    // })

    /* The `useEffect` hook is used to perform side effects in a React component. In this case, the
    effect is triggered when the `isOpenorgDiv` state variable changes. */
    useEffect(() => {
        setDisplayEmptyMsg('')
        if (isOpen) {
            value !== '' && handleOrganizationListSearch("")
        }
    }, [isOpenorgDiv])

    return (
        <>
            <div className='relative' ref={ref}>
                <button
                    ref={buttonRef}
                    onClick={() => { setisOpen(!isOpen); setIsOpenorgDiv(!isOpenorgDiv) }}
                    className={`border ${emptyField ? 'border-[#C81720]' : 'border-[#C5C9DA] '}  disabled:bg-[#E7EAF4] rounded-lg px-3.5 py-[11px] text-base font-normal 
                                 text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center`}
                    disabled={disabled}
                    id={id}
                >
                    <p id={id} className={`${(selectedOrganizationName.patient_first_name === "" || selectedOrganizationName.patient_first_name === undefined) ? 'text-[#52555D] ' : 'text-[#000B17] '}text-start text-sm more-lines`}>{(selectedOrganizationName.patient_first_name === "" || selectedOrganizationName.patient_first_name === undefined)
                        ? placeholder
                        : `${selectedOrganizationName.patient_last_name} ${selectedOrganizationName.patient_first_name}`}</p>
                    <img loading='lazy' decoding='async' src="/images/dropdown_green.svg" alt="icon" className={`${isOpen ? "transform rotate-180" : ""}`} />
                </button>
                <ul className={`py-4 pr-1 pl-4 rounded-lg bg-white z-[9] absolute top-[46px] w-full left-0 border border-[#C5C9DA] ${isOpen ? "" : "hidden"}`} ref={dropdownRef}>
                    <li>
                        <ul>
                            <li>
                                <div className="relative pr-3">
                                    <label htmlFor=""></label>
                                    <input
                                        type="text"
                                        ref={inputRef}
                                        autoComplete={"off"}
                                        id={isMonitor !== undefined ? 'search-value-patient' : "search"}
                                        placeholder="Search by last name"
                                        className="border border-[#C5C9DA] rounded-[16px] pl-9 px-3 py-1.5 w-full outline-none"
                                        onChange={(e) => { handleOrganizationListSearch(e.target.value) }}
                                        value={value} />
                                    <img src="/images/search_gray.svg" alt="icon" className="absolute top-[50%] -translate-y-[50%] left-3" />
                                </div>
                            </li>
                        </ul>
                        {organizationFetching &&
                            <div className='flex justify-center items-center mb-[40px] mt-[90px]'>
                                <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-12 w-12  mt-[-45px] spin-animation"></div>
                            </div>

                        }
                        {(!organizationFetching && displayEmptyMsg === "") ?
                            <ul className={`max-h-[440px] overflow-auto scrollbar_gray pr-3`}>
                                {!organizationFetching && organizationData !== undefined && organizationData?.data?.map((item, i) => (
                                    <li key={item._id} className='flex justify-between items-center p-2'>
                                        <div className="">
                                            <p
                                                id={isMonitor !== undefined ? i + 'patient' : optionId}
                                                data-testid={i + 'dropdown'}
                                                onClick={() => { handleFetchSubdivision(item), setDisplayEmptyMsg('') }}
                                                title={item?.patient_id}
                                                htmlFor={i}
                                                className="text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4 more-lines"
                                            >{item?.last_name}, {item?.first_name} {item?.patient_id}</p>
                                        </div>
                                    </li>
                                ))}
                            </ul> :
                            <p className="mt-2 text-center">{organizationFetching ? "" : displayEmptyMsg}</p>}
                    </li>

                </ul>
            </div>
        </>
    )
}
